module.exports = __webpack_public_path__ + "static/media/cat.d49260e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/cat.png
// module id = 239
// module chunks = 0